import {
    JOBSTRUCTURE_FETCHING,
    JOBSTRUCTURE_FAILED,
    JOBSTRUCTURE_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case JOBSTRUCTURE_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case JOBSTRUCTURE_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case JOBSTRUCTURE_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  